import { useState, useEffect } from 'react';

const useMobile = (width) => {
  const [isMobile, setIsMobile] = useState(false);
  const winWidth = width || 1023;

  useEffect(() => {
    const detectMobile = () => {
      setIsMobile(window.innerWidth <= winWidth);
    };

    window.addEventListener('resize', detectMobile);

    detectMobile();

    return () => {
      window.removeEventListener('resize', detectMobile);
    }
  }, [isMobile]);

  return isMobile;
}

export {
  useMobile
}
